// src/hooks/useAdminSync.ts
import { useMutation } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";

const API_BASE = import.meta.env.VITE_API_URL ?? "/api";

function authHeaders() {
  const token = (localStorage.getItem("auth_token") || "").trim();
  const bearer = token.toLowerCase().startsWith("bearer ") ? token.slice(7).trim() : token;
  return bearer ? { Authorization: `Bearer ${bearer}` } : {};
}

async function fetchJson<T = any>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const res = await fetch(input, init);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as any)?.detail || `Erreur ${res.status}`);
  return data as T;
}

export function useTestMssql() {
  const { toast } = useToast();
  return useMutation({
    mutationFn: async () =>
      fetchJson<{ ok: boolean; message?: string }>(`${API_BASE}/admin/sync/test-connection`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify({}),
      }),
    onError: (e: any) => {
      toast({ title: "Test connexion MSSQL", description: e?.message ?? "Erreur", variant: "destructive" });
    },
  });
}

export function usePreviewSync() {
  const { toast } = useToast();
  return useMutation({
    mutationFn: async () =>
      fetchJson<any>(`${API_BASE}/admin/sync/preview`, {
        method: "GET",
        headers: { Accept: "application/json", ...authHeaders() },
      }),
    onError: (e: any) => {
      toast({ title: "Prévisualisation", description: e?.message ?? "Erreur", variant: "destructive" });
    },
  });
}

export function useRunSync() {
  const { toast } = useToast();
  return useMutation({
    mutationFn: async () =>
      fetchJson<{ ok: boolean; summary?: any }>(`${API_BASE}/admin/sync/run`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify({}),
      }),
    onError: (e: any) => {
      toast({ title: "Import MSSQL", description: e?.message ?? "Erreur", variant: "destructive" });
    },
  });
}
